import React from 'react'

const EvaluationProcessScheduleTemplate = ({ data }) => {
  const {
    studentName = '',
    roleName = '',
    companyName = '',
    rounds = [],
    placementOfficerName = '',
    placementOfficerContact = '',
    signatureName = '',
    signatureRole = '',
    signatureInstitute = '',
    signatureContact = ''
  } = data || {}

  const formatDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    })
  }

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      {/* Section 1: General announcement to students */}
      <p>Dear {studentName},</p>

      <p style={{ paddingTop: '8px' }}>
        We are glad to share the evaluation process for the role of {roleName} at {companyName}. Please find the details below:
      </p>

      <p style={{ paddingTop: '8px', fontWeight: 'bold' }}>Evaluation Rounds:</p>

      {rounds && rounds.length > 0 ? (
        rounds.map((round, index) => (
          <div key={round.id || index} style={{ paddingLeft: '15px', paddingTop: '8px' }}>
            <p style={{ margin: '0px', fontWeight: 'bold' }}>
              Round {index + 1}: {round.name || '-'}
            </p>
            <p style={{ margin: '0px', paddingLeft: '15px' }}>
              Date: {formatDate(round.startDate)}
              {round.endDate && round.startDate !== round.endDate ? ` to ${formatDate(round.endDate)}` : ''}
            </p>
            <p style={{ margin: '0px', paddingLeft: '15px' }}>
              Description: <span dangerouslySetInnerHTML={{ __html: round.description || '' }} />
            </p>
          </div>
        ))
      ) : (
        <p style={{ paddingLeft: '15px' }}>No rounds have been scheduled yet.</p>
      )}

      <p style={{ paddingTop: '8px' }}>
        Further rounds (if any) will be informed in due course.
      </p>

      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>Best Regards,</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>
        {signatureName || placementOfficerName}
      </p>
      {signatureRole ? (
        <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureRole}</p>
      ) : null}
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>
        {signatureInstitute || ''}
      </p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>
        {signatureContact || placementOfficerContact}
      </p>

    
    </div>
  )
}

export default EvaluationProcessScheduleTemplate
